import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const multiselectPillFn = /* @__PURE__ */ createRecipe('multiselect-pill', {}, [])

const multiselectPillVariantMap = {}

const multiselectPillVariantKeys = Object.keys(multiselectPillVariantMap)

export const multiselectPill = /* @__PURE__ */ Object.assign(memo(multiselectPillFn.recipeFn), {
  __recipe__: true,
  __name__: 'multiselectPill',
  __getCompoundVariantCss__: multiselectPillFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: multiselectPillVariantKeys,
  variantMap: multiselectPillVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, multiselectPillVariantKeys)
  },
  getVariantProps: multiselectPillFn.getVariantProps,
})